export const alertBackgroundColorMap = {
    success: 'support_success_background',
    error: 'support_error_background',
    info: 'support_information_background',
    warning: 'support_warning_background',
    grey: 'ui_05',
};
export const alertBorderColorMap = {
    success: 'support_success_border',
    error: 'support_error_border',
    info: 'support_information_border',
    warning: 'support_warning_border',
    grey: 'ui_04',
};
export const alertColorMap = {
    success: 'support_success',
    error: 'support_error',
    info: 'support_information',
    warning: 'support_warning',
    grey: 'text_02',
};
